import { IPageTabNavLink } from "../interfaces-and-types";

export const productsNavLinks: IPageTabNavLink[] = [
    {
        name: 'Products',
        route: '',
    },
]